import { useForm, FormProvider } from 'react-hook-form';
import { IJobDescription } from '@/states/job.state';
import JobDescriptionContent from '@/components/company/job/JobDescriptionContent';

export default function JobDescription() {
  const formControl = useForm<IJobDescription>({ defaultValues: { name: '' } });

  return (
    <FormProvider {...formControl}>
      <JobDescriptionContent />
    </FormProvider>
  );
}
